import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { curSym } from "../../../utils/pip";
import { useNavigate } from "react-router-dom";
import ReactPagination from "../../../layout/ReactPagination";
import PaginationDropdown from "../../../layout/PaginationDropdown";
import {
  deleteProduct,
  fetchCartDetails,
  updateCartDetail,
} from "../../../redux/action/orderAction";
import Loader from "../../../components/other/Loader";
import NoRecord from "../../../components/other/NoRecord";
import { pageRoutes } from "../../../routes/pageRoutes";
import QuantitySelector from "../../component/QuantitySelector";

const CartTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, cartList } = useSelector((state) => state.orderReducer);
  const [productDetails, setProductDetails] = useState();
  const [list, setList] = useState();

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(10);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  // Get paginated data for the current page
  const paginateOrders = list?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  useEffect(() => {
    setList(cartList);
  }, [cartList]);

  function calculateCartTotals() {
    let subtotal = 0;
    let totalDiscount = 0;

    cartList.forEach((item) => {
      const price = parseFloat(item?.product_details?.price);
      const discount = parseFloat(item?.product_details?.discount);
      const quantity = item?.quantity;

      subtotal += price * quantity;
      totalDiscount += discount * quantity;
    });

    const totalPrice = subtotal - totalDiscount;

    return {
      subtotal: subtotal?.toFixed(2),
      totalDiscount: totalDiscount?.toFixed(2),
      totalPrice: totalPrice?.toFixed(2),
    };
  }

  const updateCart = (id, qty) => {
    const callback = (response) => {
      if (response.success);
      dispatch(fetchCartDetails());
    };
    dispatch(
      updateCartDetail({
        payload: {
          product_id: id,
          quantity: qty,
        },
        callback,
      })
    );
  };
  const handleDeleteProduct = (id, qty) => {
    const callback = (response) => {
      if (response.success);
      dispatch(fetchCartDetails());
    };
    dispatch(
      deleteProduct({
        payload: productDetails,
        callback,
      })
    );
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            <form class="col-md-12" method="post">
              <div class="ct_back_to_shop">
                <a
                  href="javascript:void(0)"
                  onClick={() => navigate(pageRoutes?.shop?.products)}
                  class="ct_single_cart_btn ct_btn_animate text-white ct_black_animation_btn"
                >
                  {" "}
                  <i class="fa-solid fa-arrow-left ms-2"></i> Back To Shop
                </a>
              </div>
              <div class="site-blocks-table">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="product-thumbnail">Image</th>
                      <th class="product-name">Product</th>
                      <th class="product-price">Price</th>
                      <th class="product-quantity">Quantity</th>
                      <th class="product-total">Total</th>
                      <th class="product-remove">Remove</th>
                    </tr>
                  </thead>
                  {paginateOrders?.length > 0 && (
                    <tbody>
                      {paginateOrders?.map((order) => (
                        <tr key={order.id}>
                          <td className="product-thumbnail">
                            <img
                              src={order?.product_images.thumbnail}
                              alt={order?.product_details.product_name}
                              className="img-fluid ct_img_50"
                            />
                          </td>
                          <td className="product-name">
                            <h2 className="h5 text-black">
                              {order?.product_details.product_name}
                            </h2>
                          </td>
                          <td>
                            {curSym}
                            {parseFloat(order?.product_details.price) -
                              parseFloat(order?.product_details.discount)}
                          </td>
                          <td>
                            <QuantitySelector
                              quantity={order?.quantity}
                              onIncrease={() =>
                                updateCart(
                                  order?.product_id,
                                  order?.quantity + 1
                                )
                              }
                              onDecrease={() =>
                                order?.quantity > 1 &&
                                updateCart(
                                  order?.product_id,
                                  order?.quantity - 1
                                )
                              }
                            />
                            {/* <div
                              class="input-group  d-flex mx-auto align-items-center quantity-container"
                              style={{ maxWidth: "120px", flexWrap: "nowrap" }}
                            >
                              <div class="input-group-prepend">
                                <button
                                  class="btn btn-outline-black decrease"
                                  type="button"
                                  onClick={() => {
                                    order?.quantity > 1 &&
                                      updateCart(
                                        order?.product_id,
                                        order?.quantity - 1
                                      );
                                  }}
                                >
                                  &minus;
                                </button>
                              </div>
                              <input
                                type="text"
                                class="form-control text-center quantity-amount"
                                style={{ width: "50px" }}
                                value={order?.quantity}
                                placeholder=""
                                aria-label="Example text with button addon"
                                aria-describedby="button-addon1"
                              />
                              <div class="input-group-append">
                                <button
                                  class="btn btn-outline-black increase"
                                  type="button"
                                  onClick={() =>
                                    updateCart(
                                      order?.product_id,
                                      order?.quantity + 1
                                    )
                                  }
                                >
                                  &#43;
                                </button>
                              </div>
                            </div> */}
                          </td>
                          <td>
                            {curSym}
                            {order?.quantity *
                              (parseFloat(order?.product_details.price) -
                                parseFloat(order?.product_details.discount))}
                          </td>
                          <td>
                            <a
                              href="javascript:void(0)"
                              data-bs-toggle="modal"
                              data-bs-target="#ct_logout_modal"
                              class="btn btn-black btn-sm"
                              onClick={() =>
                                setProductDetails({
                                  product_id: order?.product_id,
                                })
                              }
                            >
                              X
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
                {list?.length == 0 && (
                  <NoRecord className={"text-center"} />
                )}
                {list?.length > 10 && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <div>
                        <PaginationDropdown
                          onChange={(val) => {
                            setPerPageList(val);
                            setCurrentPage(0);
                          }}
                        />
                      </div>
                      <div>
                        <ReactPagination
                          pageCount={Math.ceil(list?.length / listPerPages)}
                          onPageChange={handlePageClick}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
          {paginateOrders?.length > 0 && (
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 pl-5 ">
                <div class="row justify-content-end ">
                  <div class="col-md-7 ct_card_total_bg">
                    <div class="row">
                      <div class="col-md-12 text-right border-bottom mb-4">
                        <h3 class="text-black h4 ">Cart Totals</h3>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <span class="text-black">Subtotal</span>
                      </div>
                      <div class="col-md-6 text-right">
                        <strong class="text-black">
                          {curSym}
                          {calculateCartTotals()?.subtotal}
                        </strong>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-md-6">
                        <span class="text-black">Discount</span>
                      </div>
                      <div class="col-md-6 text-right">
                        <del className="old-price">
                          {curSym}
                          {calculateCartTotals()?.totalDiscount}
                        </del>
                      </div>
                    </div>
                    <div class="row mb-5">
                      <div class="col-md-6">
                        <span class="text-black">Total</span>
                      </div>
                      <div class="col-md-6 text-right">
                        <strong class="text-black">
                          {" "}
                          {curSym}
                          {calculateCartTotals()?.totalPrice}
                        </strong>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <button
                          class="btn btn-secondary ct_btn_animate w-100"
                          onClick={() => navigate(pageRoutes?.checkout)}
                        >
                          Proceed To Checkout
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        className="modal fade ct_assets_modal"
        id="ct_logout_modal"
        tabIndex="-1"
        aria-labelledby="ct_logout_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pt-0">
              <button
                type="button"
                className="btn-close ct_cloose_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body border-0 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16px"
                viewBox="0 0 448 512"
              >
                <path
                  d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                  fill="#bb0000"
                />
              </svg>
              <h4 className="text-center mb-2 ct_fw_600">Remove Product</h4>
              <p className="text-center ct_grey_text">
                Are you sure you want to remove this product from your cart?
              </p>
              <div className="modal-footer border-0 justify-content-center">
                <button
                  type="button"
                  className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <a
                  onClick={() => {
                    handleDeleteProduct();
                    // clearAuth();
                    // navigate(pageRoutes?.login);
                  }}
                  href="javascript:void(0)"
                  type="button"
                  data-bs-dismiss="modal"
                  className="bg-danger ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  style={{ borderColor: "rgb(220, 53, 69)" }}
                >
                  Confirm
                </a>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartTable;
